<template>
  <section class="header_table_block">
    <div class="title-container">
      <div v-if="!!messengerConfig.ribbon" class="ribbon-container">
        <BaseRibbon
          :text="messengerConfig.ribbon"
          color="var(--ribbon-primary-color)"
        />
      </div>
      <h3 class="selected-numbers-title">
        <i
          :class="messengerConfig.icon"
          :style="{ color: messengerConfig.color }"
        />
        {{ title }}
        <span :style="{ color: messengerConfig.color }"
          >{{ messengerConfig.title }}
          <span v-show="countTitle !== undefined" style="letter-spacing: 1px"
            >({{ countTitle }})</span
          ></span
        >:
      </h3>
    </div>
    <BaseSearchInput
      :applied="sendInput ?? ''"
      :loading="loading"
      :min-length="minLength"
      :max-length="maxLength"
      :numeric-only="numericOnly"
      @submit-search="emits('submitInput', $event || null)"
    />
  </section>
</template>

<script setup>
import { computed } from "vue";
import MESSENGERS from "@/data/messengers";
import BaseRibbon from "@/components/ui/BaseRibbon.vue";
import BaseSearchInput from "@/components/ui/BaseSearchInput.vue";

const props = defineProps({
  title: String,
  messenger: String,
  countTitle: Number,
  sendInput: String,
  loading: {
    type: Boolean,
    default: false,
  },
  // messengers not in the MESSENGERS map (tiktok) pass their entry directly
  config: {
    type: Object,
    default: null,
  },
  // usernames are searched by text, numbers by digits only
  numericOnly: {
    type: Boolean,
    default: true,
  },
  minLength: {
    type: [String, Number],
    default: 4,
  },
  maxLength: {
    type: [String, Number],
    default: 15,
  },
});

const messengerConfig = computed(
  () => props.config ?? MESSENGERS[props.messenger]
);

const emits = defineEmits(["submitInput"]);
</script>

<style lang="scss" scoped>
.header_table_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 12px 6px 12px;
}

.title-container {
  position: relative;
}

.bi {
  font-size: 24px;
  &:before {
    font-weight: 600 !important;
  }
}

.selected-numbers-title {
  position: relative;
  font-family: "Gilroy";
  text-transform: uppercase;
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
}

.ribbon-container {
  position: absolute;
  top: -35px;
  left: -16px;
}

@media (max-width: 740px) {
  .header_table_block {
    // flex-direction: column;
    // align-items: flex-start;
    gap: 10px;
    margin: 12px 2px 20px;
  }
  .selected-numbers-title {
    font-size: 20px;
  }
  .bi {
    font-size: 16px;
  }
  .ribbon-container {
    top: -30px;
  }
}
@media (max-width: 640px) {
  .title-container {
    width: 100%;
  }
  .ribbon-container {
    top: -24px;
    left: -13px;
  }
}
</style>
